import Vue from 'vue';

import VueCalculateMyseed from './vue-calculate-myseed.vue';

export default (el) =>
  new Vue({
    el,
    render: (h) => h(VueCalculateMyseed),
  });
